import React, { useState } from 'react';
import PropTypes from 'prop-types';

/** Label / value row on a Review step (Retrieval Agent and Generate-with-AI). */
export const ReviewRow = ({ label, value, alignValueLeft = false }) => (
    <div className="gdai-review-row">
        <div className="gdai-review-label fs-unmask">{label}</div>
        <div
            className={`gdai-review-value${alignValueLeft ? ' gdai-review-value--left' : ''} fs-unmask`}
        >
            {value || '—'}
        </div>
    </div>
);

ReviewRow.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.node,
    alignValueLeft: PropTypes.bool,
};

/** Character count above which a long review value collapses behind Show more. */
const SHOW_MORE_THRESHOLD = 280;

/**
 * Review row for long free text (Description): clamps the value and
 * toggles it with a Show more / Show less link (Figma review frame).
 */
export const ExpandableReviewRow = ({ label, value }) => {
    const [expanded, setExpanded] = useState(false);
    const text = value || '';
    const collapsible = text.length > SHOW_MORE_THRESHOLD;
    return (
        <div className="gdai-review-row">
            <div className="gdai-review-label fs-unmask">{label}</div>
            <div className="gdai-review-value gdai-review-value--left fs-unmask">
                {text ? (
                    <>
                        <div className={collapsible && !expanded ? 'gdai-review-value__clamp' : undefined}>
                            {text}
                        </div>
                        {collapsible ? (
                            <button
                                type="button"
                                className="gdai-review-toggle fs-unmask"
                                onClick={() => setExpanded((prev) => !prev)}
                            >
                                {expanded ? 'Show less' : 'Show more'}
                            </button>
                        ) : null}
                    </>
                ) : (
                    '—'
                )}
            </div>
        </div>
    );
};

ExpandableReviewRow.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
};
